'use client';

import { Toaster } from 'react-hot-toast';

/**
 * The one and only Toaster, mounted in the root layout.
 *
 * There must be exactly one. Pages used to mount their own on top of this,
 * and react-hot-toast keeps its pause state in a single global store: when a
 * page unmounted during navigation its Toaster left that store paused, which
 * froze the dismiss timers for every toast still on screen. The visible
 * symptom was a toast that never went away - most obviously "Login
 * successful!", which fires just as the sign-in page is being replaced.
 *
 * Styling and durations live here so every toast on the site matches.
 */
export default function ToasterProvider() {
  return (
    <Toaster data-component-id="src/components/common/ToasterProvider.tsx:19:4" data-component-path="src/components/common/ToasterProvider.tsx" data-component-line="19" data-component-end-line="45" data-component-file="ToasterProvider.tsx" data-component-name="Toaster" data-component-content="%7B%22elementName%22%3A%22Toaster%22%7D"
      position="top-right"
      reverseOrder={false}
      gutter={8}
      containerStyle={{ top: 20, right: 20 }}
      toastOptions={{
        duration: 4000,
        style: {
          background: '#fff',
          color: '#111',
          padding: '14px 16px',
          borderRadius: '10px',
          boxShadow: '0 6px 20px rgba(0, 0, 0, 0.12)',
          maxWidth: '420px',
        },
        success: {
          duration: 3000,
          iconTheme: { primary: '#16a34a', secondary: '#fff' },
          style: { borderLeft: '4px solid #16a34a' },
        },
        error: {
          duration: 5000,
          iconTheme: { primary: '#dc2626', secondary: '#fff' },
          style: { borderLeft: '4px solid #dc2626' },
        },
      }}
    />
  );
}
